import React from 'react'

import { Portlet, Button, Table, Col, Row } from '_zari/core'

import NuevaPresentacionModal from './modals/nuevo'
import EditarPresentacionModal from './modals/editar'

import { ZrSwal } from 'utils'

const tableHeaderRows = [{ label: 'UNIDAD DE MEDIDA' }, { label: 'EQUIVALENCIA', width: 120 }, { label: '', width: 60 }]

const PresentacionesSection = ({ vMoneda, presentaciones, dispatch }) => {
  const editarData = React.useRef({})

  const cantidadPresentaciones = React.useMemo(() => presentaciones.length, [presentaciones])

  const [mostrarNuevaPresentacionModal, setMostrarNuevaPresentacionModal] = React.useState(false)
  const [mostrarEditarPresentacionModal, setMostrarEditarPresentacionModal] = React.useState(false)

  const agregarPresentacion = React.useCallback(
    payload => {
      if (payload.equivalencia !== 1 && cantidadPresentaciones === 0) {
        ZrSwal.showAlert({
          tipo: 'error',
          mensaje: 'La primera presentación debe tener equivalencia 1.'
        })
        return
      }

      dispatch({ type: 'agregar', payload })
      setMostrarNuevaPresentacionModal(false)
    },
    [dispatch, cantidadPresentaciones]
  )

  const actualizarPresentacion = React.useCallback(
    payload => {
      if (payload.equivalencia !== 1 && cantidadPresentaciones === 1) {
        ZrSwal.showAlert({
          tipo: 'error',
          mensaje: 'La primera presentación debe tener equivalencia 1.'
        })
        return
      }

      dispatch({ type: 'actualizar', payload })
      setMostrarEditarPresentacionModal(false)
    },
    [dispatch, cantidadPresentaciones]
  )

  const clickEditar = React.useCallback(
    ({ _idFila }) => {
      const fila = presentaciones.find(row => row._idFila === _idFila)
      editarData.current = fila
      setMostrarEditarPresentacionModal(true)
    },
    [presentaciones]
  )

  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row className='mb-2'>
            <Col className='text-right'>
              <Button onClick={e => setMostrarNuevaPresentacionModal(true)}>Nuevo</Button>
            </Col>
          </Row>
          <Table.ClientSide
            headRows={tableHeaderRows}
            filas={presentaciones}
            rowTemplate={row => (
              <Table.Row hover key={row._idFila}>
                <Table.Cell>{row.nombreUnidadDeMedida || '--'}</Table.Cell>
                <Table.Cell>{row.equivalencia || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _idFila: row._idFila })}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _idFila: row._idFila })}>
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevaPresentacionModal && (
        <NuevaPresentacionModal
          handleClose={e => setMostrarNuevaPresentacionModal(false)}
          show={mostrarNuevaPresentacionModal}
          agregarPresentacion={agregarPresentacion}
          cantidadPresentaciones={cantidadPresentaciones}
          vMoneda={vMoneda}
        />
      )}
      {mostrarEditarPresentacionModal && (
        <EditarPresentacionModal
          modalData={editarData.current}
          handleClose={e => setMostrarEditarPresentacionModal(false)}
          show={mostrarEditarPresentacionModal}
          actualizarPresentacion={actualizarPresentacion}
          vMoneda={vMoneda}
        />
      )}
    </>
  )
}

export default React.memo(PresentacionesSection)
